<template>
  <v-card flat tile class="elevation-2">
    <v-card color="primary" class="elevation-0 text-left">
      <v-card-title class="px-4 text-left py-3">
        <v-layout  wrap>
          <v-flex xs12 sm12 md8 lg8>
            <h2 class="text-white headline font-weight-bold mt-1">Information</h2>
            <p class="text-white subtitle-2 mb-0">Basic User information</p>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 class="text-left text-md-right">
            <v-tooltip top  v-if="!edit">
              <template v-slot:activator="{ on }">
                <v-btn
                  depressed
                  @click="edit = true"
                  fab 
                  dark 
                  color="white"
                  v-on="on"
                >
                  <v-icon dark class="primary--text">edit</v-icon>
                </v-btn>
              </template>
              <span>Edit info</span>
            </v-tooltip>

          
            <template v-else>
              <v-tooltip top >
                <template v-slot:activator="{ on }">
                  <v-btn
                    depressed
                    @click="edit = false"
                    fab 
                    dark 
                    color="white"
                    v-on="on"
                    :class="'mr-2'"
                  >
                  <v-icon dark class="primary--text">close</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    depressed
                    @click="updateBasicInfo()"
                    fab 
                    dark 
                    color="white"
                    v-on="on"
                  >
                    <v-icon dark class="primary--text">check</v-icon>
                  </v-btn>
                </template>
                <span>Update Info</span>
              </v-tooltip>
            </template>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>

    <!-- content --> 
    <v-form ref="basicInfoForm" lazy-validation class="px-4 py-4">
      <v-flex xs12>
        <v-text-field
          v-model="form.email"
          :rules="fieldRequired"
          :disabled="!edit"
          label="Email"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          v-model="form.first_name"
          :rules="fieldRequired"
          :disabled="!edit"
          label="First Name"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          v-model="form.last_name"
          :rules="fieldRequired"
          :disabled="!edit"
          label="Last Name"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          v-model="form.phone"
          label="Phone"
          :disabled="!edit"
          autocomplete="off"
        ></v-text-field>
      </v-flex>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import { isEmpty } from 'lodash';

export default {

  data() {
    return {
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      edit: false,
      form: {
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
      }
    };
  },

  computed: {
    ...mapGetters({
      userProfile: 'user/userProfile',
      userProfileObj: 'user/userProfileObj',
    }),
  },
 watch: {
   userProfile() {
    if(!_.isEmpty(this.userProfileObj)) {
      this.form.email = this.userProfileObj.email;
      this.form.first_name = this.userProfileObj.first_name;
      this.form.last_name = this.userProfileObj.last_name;
      this.form.phone = this.userProfileObj.phone;
    } 
   }
 },
  mounted() {
    if(!_.isEmpty(this.userProfileObj)) {
      this.form.email = this.userProfileObj.email;
      this.form.first_name = this.userProfileObj.first_name;
      this.form.last_name = this.userProfileObj.last_name;
      this.form.phone = this.userProfileObj.phone;
    } 
  },
  methods: {
    /**
     * Update basic Info
     */
    updateBasicInfo() {
      if (this.$refs.basicInfoForm.validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/users/${ this.userProfileObj.id }`;
        AuthApi.patchApi(url, this.form)
        .then((res) => {
          this.getAllUsersForBusiness();
          this.edit = false;
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
          this.spinner(false);
          this.closeModal();

        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
        });
      }
    },

    /**
   * Get all users for business
   */
    getAllUsersForBusiness() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}/users`;
      AuthApi.getApi(url)
      .then((res) => {
        let rawdata = res.data.payload;
        rawdata.map(item => {
          if(item.status == 'active') {
            item.status_bool = true;
          } else {
            item.status_bool = false;
          }
        })
        this.userlist(rawdata);
      })
      .catch((err) => {
        console.log(err.response.data.msg);
      });
    },

    closeModal() {
      this.setUserProfile(false);
      this.setUserProfileObj({});
    },
    ...mapActions({
      snackbar: 'snackbar/snackbar',
      spinner: 'spinner/spinnerStatus',
      setUserProfileObj: 'user/setUserProfileObj',
      setUserProfile: 'user/setUserProfile',
      userlist: 'user/setList',
    }),
  },
};
</script>